import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState, RoomCountFilterState, RoomCountRange } from '@immosky/types';
import { Subscription } from 'rxjs';
import {
  resetRoomCountFilter,
  selectRoomCountFilterState,
  setRoomCountFilter,
} from '@immosky/object-search-filter';

@Component({
  selector: 'app-room-count-filter-dropdown',
  templateUrl: './room-count-filter-dropdown.component.html',
  styleUrls: ['./room-count-filter-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomCountFilterDropdownComponent {
  private subscription: Subscription;

  appliedFilter!: RoomCountRange;
  currentFilter!: RoomCountRange;

  isActive = false;

  get roomCountIsSameForMinAndMax(): boolean {
    return this.appliedFilter.min.value === this.appliedFilter.max.value;
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    this.subscription = this.store
      .pipe(select(selectRoomCountFilterState))
      .subscribe((filterState: RoomCountFilterState) => {
        this.appliedFilter = {
          ...filterState.filter,
        };
        this.currentFilter = {
          ...filterState.filter,
        };
        this.isActive = filterState.isActive;
        this.cdRef.markForCheck();
      });
  }

  select(filter: RoomCountRange) {
    this.currentFilter = filter;
  }

  applyChanges() {
    if (this.currentFilter) {
      this.store.dispatch(
        setRoomCountFilter({
          filter: this.currentFilter,
        })
      );
    }
  }

  reset() {
    this.store.dispatch(resetRoomCountFilter());
  }
}
